import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService, TeamService, UserRole } from '@oxypeak/commons';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable()
export class RedirectByRoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private teamService: TeamService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    // First, wait for the user to be logged in
    return this.authService.isLoggedIn$.pipe(
      switchMap((isLoggedIn) => {
        if (!isLoggedIn) {
          // Not logged in: start login flow and block navigation
          this.authService.login();
          return of(false);
        }
        // Get the user role subito dopo il login
        const userRole = this.authService.getUserRole();
        if (!userRole) {
          return of(this.router.createUrlTree(['require-login']));
        }
        // Se SuperAdmin, consenti subito la navigazione verso 'admin'
        if (userRole === UserRole.SuperAdmin) {
          return of(this.router.createUrlTree(['admin']));
        }
        // Per gli altri ruoli, attendi il team
        return this.teamService.whenUserTeam().pipe(
          map((team) => {
            if (!team) {
              // No team, redirect to logging-in
              return this.router.createUrlTree(['logging-in']);
            }
            switch (userRole) {
              case UserRole.Trainer:
                return this.router.createUrlTree([team.id, 'real-time']);
              case UserRole.Player:
                return this.router.createUrlTree([team.id, 'analyze']);
              default:
                return this.router.createUrlTree([team.id, 'real-time']);
            }
          })
        );
      })
    );
  }
}
